<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_67_6956)">
<path d="M23 9.33334H22V8.33334C22 6.31067 20.356 4.66667 18.3333 4.66667H5.00001C2.97734 4.66667 1.33334 6.31067 1.33334 8.33334V15.6667C1.33334 17.6893 2.97734 19.3333 5.00001 19.3333H18.3333C20.356 19.3333 22 17.6893 22 15.6667V14.6667H23C23.552 14.6667 24 14.2187 24 13.6667V10.3333C24 9.78134 23.552 9.33334 23 9.33334ZM20 15.6667C20 16.5853 19.252 17.3333 18.3333 17.3333H5.00001C4.08134 17.3333 3.33334 16.5853 3.33334 15.6667V8.33334C3.33334 7.41467 4.08134 6.66667 5.00001 6.66667H18.3333C19.252 6.66667 20 7.41467 20 8.33334V15.6667Z" />
<path d="M17.6667 8.00001H5.66668C5.11439 8.00001 4.66668 8.44772 4.66668 9.00001V15C4.66668 15.5523 5.11439 16 5.66668 16H17.6667C18.219 16 18.6667 15.5523 18.6667 15V9.00001C18.6667 8.44772 18.219 8.00001 17.6667 8.00001Z" />
</g>
<defs>
<clipPath id="clip0_67_6956">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
